import React from "react";
import closeTokens from "@amzn/meridian-tokens/base/icon/close";
import Sheet from "@amzn/meridian/sheet";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import Icon from "@amzn/meridian/icon";
import Heading from "@amzn/meridian/heading";
import Box from "@amzn/meridian/box";
import arrowLeftLargeTokens from "@amzn/meridian-tokens/base/icon/arrow-left-large";
import { useIntl } from "react-intl";
import SheetContent from "./containers/SheetContent";
import useInlineHelp from "./hooks/useInlineHelp";
import withIntl from "./hoc/withIntl";
import { getpageHistoryStoreValue } from "./store/pageHistoryStore";
var SlideOutSheet = function() {
    var pageHistory = getpageHistoryStoreValue();
    var shouldRenderBackButton = pageHistory.length > 0;
    var _useInlineHelp = useInlineHelp(), pageId = _useInlineHelp.pageId, closeInlineHelpSheet = _useInlineHelp.closeInlineHelpSheet, navigateToPrevPage = _useInlineHelp.navigateToPrevPage;
    var formatMessage = useIntl().formatMessage;
    var open = !!pageId;
    if (!pageId) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(Sheet, {
        type: "overlay",
        side: "right",
        open: open,
        onClose: closeInlineHelpSheet
    }, /*#__PURE__*/ React.createElement(Column, {
        spacing: "300",
        width: "320px",
        height: "100%"
    }, /*#__PURE__*/ React.createElement(Row, {
        alignmentHorizontal: "justify"
    }, /*#__PURE__*/ React.createElement(Row, {
        spacing: "none"
    }, shouldRenderBackButton && /*#__PURE__*/ React.createElement(Button, {
        onClick: navigateToPrevPage,
        type: "icon"
    }, /*#__PURE__*/ React.createElement(Icon, {
        tokens: arrowLeftLargeTokens
    })), /*#__PURE__*/ React.createElement(Heading, {
        level: 2
    }, formatMessage({
        id: "messages.dev_app.title"
    }))), /*#__PURE__*/ React.createElement(Button, {
        onClick: closeInlineHelpSheet,
        type: "icon"
    }, /*#__PURE__*/ React.createElement(Icon, {
        tokens: closeTokens
    }))), /*#__PURE__*/ React.createElement(Box, {
        overflowY: "scroll"
    }, /*#__PURE__*/ React.createElement(SheetContent, {
        pageId: pageId
    }))));
};
export default withIntl(SlideOutSheet);

//# sourceMappingURL=SlideOutSheet.js.map